<template>
  <div class="repairs">
    <div class="con">
      <div class="xin">
        <img :src="user.avatar" alt="" />
        <span>{{ user.nickname }}</span>
      </div>
      <div class="she">
        <div>
          <span>设备名称</span>
          <input type="text" placeholder="设备名称" v-model="name" />
        </div>

      </div>
      <div class="she">
        <div>
          <span>报修类别</span>
          <select v-model='type' style="width:50%">
            <option value="1">维修</option>
            <option value="2">保洁</option>
          </select>
        </div>

      </div>
      <div class="she">
        <div>
          <span>联系电话</span>
          <input type="number" placeholder="联系电话" v-model="phone" name="" id="" />
        </div>

      </div>
      <div class="pai">
        <span class="title">拍照图片</span>
        <div class="imgBoxs">
          <div class="imgbox" v-for="(item, index) in refund_reason_wap_img" :key="index">
            <img :src="item" alt="" />
          </div>
          <VueCoreImageUpload class="btn btn-primary" :crop="false" compress="80" @imageuploaded="imageuploaded"
            :headers="headers" :max-file-size="5242880" :credentials="false" inputAccept="image/*" inputOfFile="file"
            :url="url" v-if="refund_reason_wap_img.length < 3">
            <div class="pictrue acea-row row-center-wrapper row-column">
              <span class="iconfont icon-icon25201"></span>
              <div>上传凭证</div>
            </div>
          </VueCoreImageUpload>
        </div>
      </div>
      <div class="miao">
        <span>{{ type == 1 ? '维修' : '保洁' }}描述</span>
        <textarea name="" placeholder="尽可能的详细描述" v-model="describe" id="" class="input"></textarea>
      </div>
      <div class="wei">
        <span>位置信息</span>
        <el-cascader v-model="value" :options="options" @change="handleChange" class="input"></el-cascader>
      </div>
      <div class="miao">
        <span>详细地址</span>
        <textarea name="" placeholder="详细地址" v-model="bei" id="" class="input"></textarea>
      </div>
    </div>
    <div class="ti">
      <button @click="submitRepairs" class="btn">立即提交</button>
    </div>
  </div>
</template>

<script>
import { postOrderProduct, postOrderComment } from "@api/store";
import { getLinkageApi, submitRepairsApi } from "@api/login";
import { getUserInfo } from "@api/user";
import { trim, VUE_APP_API_URL } from "@utils";
import { required } from "@utils/validate";
import VueCoreImageUpload from "vue-core-image-upload";
import { validatorDefaultCatch } from "@utils/dialog";
export default {
  components: {
    VueCoreImageUpload,
  },
  props: {},
  data() {
    return {
      dialogImageUrl: "",
      dialogVisible: false,
      disabled: false,
      select: "",
      user: {},
      show: false,
      name: "",
      describe: "",
      bei: "",
      orderCon: {
        cartProduct: {
          productInfo: {},
        },
      },
      scoreList: [
        {
          name: "商品质量",
          stars: ["", "", "", "", ""],
          index: -1,
        },
        {
          name: "服务态度",
          stars: ["", "", "", "", ""],
          index: -1,
        },
      ],
      value: [],
      options: [],
      url: `${VUE_APP_API_URL}/upload/image`,
      // url: `https://dggj.ccloud8.cn/api/upload/image`,
      headers: {
        "Authori-zation": "Bearer " + this.$store.state.app.token,
      },
      uploadPictures: [],
      expect: "",
      unique: this.$route.params.id,
      refund_reason_wap_img: [],
      phone: '',
      type: 1,
    };
  },
  mounted() {
    getUserInfo().then((res) => {
      this.user = res.data;
      this.phone = res.data.phone;
    });
    getLinkageApi().then((res) => {
      // console.log(res);
      this.options = res.data;
    });
  },
  methods: {
    imageuploaded(res) {
      if (res.status !== 200)
        return this.$dialog.error(res.msg || "上传图片失败");
      this.refund_reason_wap_img.unshift(res.data.url);
    },
    handleChange() {
      // console.log(this.value);
      this.value.forEach((item) => {
        if (item == "其它") {
          this.show = true;
        } else {
          this.show = false;
        }
      });
    },
    handleRemove(file) {
      console.log(file);
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleDownload(file) {
      console.log(file);
    },
    submitRepairs() {
      // if (this.name.length == 0) {
      //   return this.$dialog.error("请填写设备名称");
      // }
      if (this.phone.length != 11) {
        return this.$dialog.error("请填写联系电话");
      }
      if (this.describe.length == 0) {
        return this.$dialog.error("请填写报修描述");
      }

      // 获取位置id
      let id = '';

      let one = this.options.find((item) => {
        return item.label === this.value[0];
      });
      id = one ? one.id : "";

      if (id.length == 0) {
        return this.$dialog.error("请选择位置信息");
      }
      if (this.bei === "") {
        return this.$dialog.error("请填写详细位置信息");
      }


      let tow;
      if (this.value[1]) {
        tow = one.children.find((item) => {
          return item.label === this.value[1];
        });
        id = tow.id;
      }
      if (this.value[2]) {
        let three = tow.children.find((item) => {
          return item.label === this.value[2];
        });
        id = three.id;
      }

      let data = {
        type: this.type,
        name: this.name,
        introduction: this.describe,
        address_id: id,
        images: this.refund_reason_wap_img.join(","),
        address_other: this.bei,
        phone: this.phone
      };

      submitRepairsApi(data)
        .then((res) => {
          if (res) {
            this.$dialog.success("提交成功");
            this.name = "";
            id = null;
            this.describe = "";
            this.refund_reason_wap_img = [];
            this.bei = "";
            this.value = [];
            // this.$router.go(-1)
            this.$router.push("/user");


          }
        })
        .catch((err) => {
          this.$dialog.success(err);
          console.log(err);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.repairs {
  background-color: #f5f5f5;
  box-sizing: border-box;
  padding: 0.2rem;

  input {
    border: none;
  }

  .pictrue.uploadBnt {
    padding: 0.2rem 0.1rem;
    border: 0.02rem solid #ddd;

    div {
      color: #ccc;
    }
  }

  .con {
    width: calc(100vw - 0.4rem);
    background-color: white;
    box-sizing: border-box;
    padding: 0.2rem;

    img {
      width: 30px;
      border-radius: 50%;
      margin-right: 0.2rem;
    }

    .xin {
      display: flex;
      align-items: center;
      padding-bottom: 0.1rem;
      border-bottom: 0.02rem dashed #ccc;
    }

    .she {
      box-sizing: border-box;
      border-bottom: 0.02rem dashed #ccc;

      div {
        display: flex;
        width: 100%;
        padding: 4px 0;
      }

      span {
        display: inline-block;
        margin-right: 0.2rem;
      }

      input {
        flex: 1;
      }
    }

    .pai {
      display: flex;
      margin-top: 0.2rem;
      min-height: 70px;

      .title {
        display: inline-block;
        margin-right: 0.2rem;
      }

      .g-core-image-upload-btn {
        height: 61px;
        width: 61px;
        border: 1px solid #ccc;
        line-height: 61px;
      }

      .el-upload .el-upload--picture-card {
        background-color: #fbfdff;
        border: 0.02rem dashed #c0ccda;
        border-radius: 6px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        width: 55px;
        height: 55px;
        cursor: pointer;
        line-height: 55px;
        vertical-align: top;
      }

      .imgBoxs {
        display: flex;

        img {
          width: 61px;
          height: 61px;
          margin-right: 10px;
          border-radius: 0;
        }
      }
    }

    .miao {
      margin-top: 0.2rem;
      display: flex;
      align-items: center;
      width: 100%;
      min-height: 76px;

      .input {
        flex: 1;
      }

      span {
        display: inline-block;
        margin-right: 0.2rem;
        white-space: nowrap;
        height: 76px;
      }

      textarea {
        min-height: 76px;
        width: 100%;
        border: 0.02rem dashed #ccc;
        color: #707070;
        box-sizing: border-box;
        padding: 0.2rem;
      }
    }

    .wei {
      height: 40px;
      line-height: 40px;
      margin-top: 0.2rem;
      width: 100%;
      display: flex;

      .input {
        flex: 1;
      }

      span {
        display: inline-block;
        margin-right: 0.2rem;
      }
    }

    // .bei {
    //   margin-top: 0.2rem;
    //   display: flex;
    //   align-items: center;
    //   width: 100%;
    //   display: flex;

    //   .input {
    //     flex: 1;
    //   }

    //   span {
    //     display: inline-block;
    //     margin-right: 0.2rem;
    //     white-space: nowrap;
    //     height: 70px;
    //   }

    //   textarea {
    //     height: 70px;
    //     // width: 100%;
    //     border: 0.02rem dashed #ccc;
    //     color: #707070;
    //     box-sizing: border-box;
    //     padding: 0.2rem;
    //   }
    // }

    // {
    //   margin-top: 10px;
    //   display: flex;
    //   align-items: center;
    //   flex-wrap: nowrap;

    //   span {
    //     margin-right: 0.2rem;
    //     display: block;
    //     // width: 78px;
    //     margin-right: 0.2rem;
    //     height: 55.6px;
    //   }

    //   textarea {
    //     padding: 10px;
    //     border: 0.02rem dashed #ccc;
    //     color: #707070;
    //     width: 100%;
    //   }
    // }
  }

  .ti {
    position: fixed;
    bottom: 0.4rem;
    width: calc(100vw - 0.4rem);

    button {
      width: calc(100vw - 0.4rem);
      margin: 0 auto;
      min-height: 30px;
      background-color: red;
      color: white;
      border-radius: 15px;
    }
  }
}
</style>
